import Masonry from "masonry-layout";
import jQueryBridget from 'jquery-bridget';
import imagesLoaded from "imagesloaded";

//jQueryBridget('imagesLoaded', imagesLoaded, $);

var articleSearch = (function () {

	var grid;

	function setup() {
		//grid = new Masonry('.news-listing', { precentPosition: true });

		//imagesLoaded('.news-listing', function () {
		//	grid.layout();
		//});

		//$('.news-listing img').imagesLoaded(function () {
		//	grid.layout();
		//});


		$(document).on("click", "#search-button", function (e) {
			e.preventDefault();
			var form = $(this).closest('form');
			$('#current-page', form).val(1);
			$(form).submit();
		});

		$(document).on('click', '#load-more', function (e) {
			e.preventDefault();
			var form = $('#article-search > form');
			$('#current-page', form).val(parseInt($('#current-page', form).val()) + 1);

			$.ajax({
				method: "post",
				data: form.serialize(),
				url: $(form).prop('action'),
				success: function (data) {
					$('#page-info').remove();
					$('#listing-results').append(data);
					doRefresh();
				}
			});
		});

		$('.articleListingPage').on('change', 'input[type=radio], select', function () {
			var form = $(this).closest('form');
			// Reset page number to 1
			$("#current-page", form).val('1');
			$(form).submit();
		});
	}

	function doRefresh() {
		//imagesLoaded('.news-listing', function () {
		//	grid.reloadItems();
		//	grid.layout();
		//});
	}

	return {
		init: function () {
			$(function () {
				setup();
			});
		},
		refresh: function () {
			doRefresh();
		}
	};
})();

export var articleSearch;